import ToggableRefinementList from "components/screener/refinements/ToggableRefinementList";
import orderBy from "lodash/fp/orderBy";
import { connectRefinementList } from "react-instantsearch-dom";

const RealEstateFundClassificationRefinementList = connectRefinementList(({ items, refine }) => {
  const classifications = orderBy(["count"], ["desc"], items);

  return (
    <div className="space-y-4 font-aeonik">
      <div className="space-y-1">
        <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Tipo</h3>
        {classifications.length === 0 && (
          <p className="font-aeonik text-sm font-normal tracking-wide text-slate-500">Nenhum tipo encontrado :(</p>
        )}
      </div>

      {classifications.length > 0 && <ToggableRefinementList items={classifications} refine={refine} />}
    </div>
  );
});

export default function RealEstateFundClassification() {
  return <RealEstateFundClassificationRefinementList attribute="classification" />;
}
